import { render, staticRenderFns } from "./Contributors.vue?vue&type=template&id=72ae8d58"
import script from "./Contributors.vue?vue&type=script&lang=js"
export * from "./Contributors.vue?vue&type=script&lang=js"
import style0 from "./Contributors.vue?vue&type=style&index=0&id=72ae8d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports